import { useLang } from '@/i18n';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';

const youtubeMap: Record<string, string> = {
    eu: 'https://www.youtube.com/embed/15WtLnpLC2A',
    de: 'https://www.youtube.com/embed/Bn703U7DVOY',
    fr: 'https://www.youtube.com/embed/4Nf9GnFuDdU',
    it: 'https://www.youtube.com/embed/HFfUAPyBUHg',
    es: 'https://www.youtube.com/embed/WNZWb_CfPwY',
};

export default function Comp() {
    const { t } = useLang('theProduct.BannerB1');
    const { locale } = getLocal();
    const youtubeHref = youtubeMap[locale] || youtubeMap.eu;

    const dataB: EcoBannerProps = {
        layout: 'top-center',
        theme: 'white',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1745586980772/ultar-kv.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1745587078982/ultra-m-kv.jpg',
        title: t('title'),
        subTitle: t('desc'),
        desc: t('desc2'),
        lChildren: t('btn1'),
        lType: 'outlined',
        lRadius: 'ellipse',
        lBtnIsYouToBe: true,
        lHref: youtubeHref,
    };
    return (
        <div className={styled.banner}>
            <EcoBanner theme="black" {...dataB} />
        </div>
    );
}
